import { AsociadoSituacion } from './asociado-situacion.model';
import { AsociadoTipo } from './asociado-tipo.model';
import { Empresa } from './empresa.model';
import { Beneficiario } from './beneficiario';
import { Prestacion } from './prestacion.model';
import { Aportacion } from './aportacion.model';
import { Baja } from './baja';
import { FormaCobro } from './formaCobro';
export class Associate {
  id: number;
  situacion: AsociadoSituacion;
  tipo: AsociadoTipo;
  empresa: Empresa;
  beneficiarios: Beneficiario[]
  numero: number;
  imq: number;
  dni: string;
  apellidosNom: string;
  nombre: string;
  apellido1: string;
  apellido2: string;
  apellidos: string;
  fnac: string;
  genero: string;
  direccion: string;
  cp: string;
  municipio: string;
  poblacion: string;
  provincia: string;
  nota_cuota_entrada: string;
  direccion_contacto: string;
  cp_contacto: string;
  municipio_contacto: string;
  poblacion_contacto: string;
  provincia_contacto: string;
  alta: string;
  baja: string;
  motivo_baja: string;
  discapacidad: string;
  tel1: string;
  tel2: string;
  email: string;
  iban: string;
  bic: string;
  mandato: string;
  password: string;
  activo_web: string;
  restaurar: string;
  restaurar_expira: string;
  entrada: number;
  jubilacion: string;
  fullname: string;
  fjub: string;
  situacionMail: string;
  tipoMail: string;
  prestacionMail: Prestacion
  prestacionMailAnio: number
  aportacionMail: Aportacion
  situacionId: number;
  tipoId: number
  mutualista: number
  mutualista_nombre: string
  bajaTipo: Baja
  base_prestacion: number
  capital_fallecimiento: number
  fecha_base_prestacion: string
  fecha_cobro: string
  orfandad_alta: string
  orfandad: number
  irpf: number
  ant_post_86: string
  formaCobro: FormaCobro
  totalTraspasos: number
  totalRescates: number
  totalFallecimientos: number
  totalBajasIT: number
	totalAportaciones: number;
  totalPrestaciones: number;
  totalDerechos: number;
  totalProductos: number;
  ultimo_derecho: number;

  constructor() {
    this.id = 0
    this.situacion = new AsociadoSituacion();
    this.tipo = new AsociadoTipo();
    this.empresa = new Empresa()
    this.beneficiarios = []
    this.numero = 0;
    this.imq = 0;
    this.dni = '';
    this.apellidosNom = '';
    this.nombre = '';
    this.apellido1 = '';
    this.apellido2 = '';
    this.apellidos = '';
    this.fnac = '';
    this.genero = '';
    this.direccion = '';
    this.cp = '';
    this.municipio = '';
    this.poblacion = '';
    this.provincia = '';
    this.nota_cuota_entrada = '';
    this.direccion_contacto = '';
    this.cp_contacto = '';
    this.municipio_contacto = '';
    this.poblacion_contacto = '';
    this.provincia_contacto = '';
    this.alta = '';
    this.baja = '';
    this.motivo_baja = '';
    this.discapacidad = '';
    this.tel1 = '';
    this.tel2 = '';
    this.email = '';
    this.iban = '';
    this.bic = '';
    this.mandato = '';
    this.password = '';
    this.activo_web = '';
    this.restaurar = '';
    this.restaurar_expira = '';
    this.entrada = 0;
    this.jubilacion = '';
    this.fjub = '';
    this.fullname = '';
    this.situacionMail = '';
    this.tipoMail = '';
    this.prestacionMail = new Prestacion();
    this.prestacionMailAnio = 0;
    this.aportacionMail = new Aportacion();
    this.situacionId = 0;
    this.tipoId = 0
    this.mutualista = 0
    this.mutualista_nombre = ''
    this.bajaTipo = new Baja()
    this.base_prestacion = 0
    this.capital_fallecimiento = 0
    this.fecha_base_prestacion = ''
    this.fecha_cobro = ''
    this.orfandad_alta = ''
    this.orfandad = 0
    this.irpf = 0
    this.ant_post_86 = ''
    this.formaCobro = new FormaCobro()
    this.totalRescates = 0
    this.totalTraspasos = 0
    this.totalFallecimientos = 0
    this.totalBajasIT = 0
    this.totalAportaciones = 0
    this.totalPrestaciones = 0
    this.totalDerechos = 0
    this.totalProductos = 0
    this.ultimo_derecho = 0
  }

}
